/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Invoice_SettingsInputs */

const vi_nav_invoice_settings = /** @type {(inputs: Nav_Invoice_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn`)
};

/**

* @param {Nav_Invoice_SettingsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_invoice_settings = /** @type {((inputs?: Nav_Invoice_SettingsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Invoice_SettingsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_invoice_settings(inputs)
});